import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteleaveListModal({show,onHide,onDelete}){

return(

<Modal show={show} onHide={onHide} centered>

<Modal.Body className="text-center">

<h4 className="mb-3">Confirm Delete</h4>

<p>You want to delete this item.</p>

<div className="d-flex justify-content-center gap-3">

<Button variant="light" onClick={onHide}>
Cancel
</Button>

<Button variant="danger" onClick={onDelete}>
Delete
</Button>

</div>

</Modal.Body>

</Modal>

);
}